import { render, staticRenderFns } from "./AppFooterEuropeanBanner.vue?vue&type=template&id=70483a76&scoped=true"
import script from "./AppFooterEuropeanBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppFooterEuropeanBanner.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AppFooterEuropeanBanner.vue?vue&type=style&index=0&id=70483a76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70483a76",
  null
  
)

export default component.exports